import useOKTAUserStore from "@app/store/useOKTAUserStore";
import TMLogoMobile from "@assets/tm_logo_mobile.svg";
import MySphLoginButton from "@header/TopHeader/MySPHLoginButton";
import UserInfo from "@header/TopHeader/UserInfo/UserInfo";
import { isProd } from "@helper/utils";
import { type UserInfoType, useUserInfo } from "@hooks/useUserInfo";
import type { ReactElement } from "react";
import { Link } from "react-router";

export function Tm90HeaderMenues(): ReactElement {
  const { userInfo } = useUserInfo();
  const OKTAUserInfo = useOKTAUserStore((state) => state.userInfo);
  const userDisplayName = OKTAUserInfo?.display_name || OKTAUserInfo?.loginid;
  return (
    <>
      <div className="pr-sm pt-2">
        <Link to="/" target="_blank" rel="noreferrer" reloadDocument>
          <img
            width={144}
            height={20}
            src={TMLogoMobile}
            className="h-5 w-auto"
            alt="tamil-murasu"
          />
        </Link>
      </div>
      <span className="border-l border-solid border-gray-400 mt-100 h-8 hidden md:inline-block"></span>

      {!isProd && (
        <div className="hidden md:inline-block">
          {userDisplayName ? (
            <UserInfo
              userInfo={
                {
                  ...userInfo,
                  lastname: userDisplayName,
                  loginId: OKTAUserInfo.loginid,
                  sub: OKTAUserInfo.reguserstatus,
                } as UserInfoType
              }
            />
          ) : (
            <MySphLoginButton />
          )}
        </div>
      )}
    </>
  );
}
